/** Tiny scaled preview of a canvas layout for dropdowns. */
import { elementValue, elPt, ptToPx } from "@/lib/labelCanvas";

const SCALE = 0.7; // px per mm

export function LayoutThumb({ layout, className = "" }) {
  const w = (layout?.width_mm || 60) * SCALE;
  const h = (layout?.height_mm || 50) * SCALE;
  const els = layout?.elements || [];
  return (
    <div
      className={`relative bg-white border border-charcoal/25 rounded-[2px] shrink-0 overflow-hidden ${className}`}
      style={{ width: w, height: h }}
      aria-hidden
    >
      {els.map((el) => {
        const left = (el.x || 0) * SCALE;
        const top = (el.y || 0) * SCALE;
        if (el.type === "qr") {
          return <div key={el.id} className="absolute bg-charcoal/70" style={{ left, top, width: (el.cell || 4) * 1.6, height: (el.cell || 4) * 1.6 }} />;
        }
        if (el.type === "barcode") {
          return <div key={el.id} className="absolute bg-charcoal/70" style={{ left, top, width: 22, height: (el.height || 8) * SCALE }} />;
        }
        return (
          <div
            key={el.id}
            className="absolute leading-none whitespace-nowrap text-charcoal"
            style={{
              left, top,
              fontSize: Math.max(3, ptToPx(elPt(el)) * 0.32),
              fontWeight: el.bold ? 700 : 400,
              maxWidth: w - left,
              overflow: "hidden",
            }}
          >
            {String(elementValue(el)).slice(0, 16)}
          </div>
        );
      })}
    </div>
  );
}
